<div ngbDropdown container="body">
    <a class="kt-font-brand bold cursor-pointer" (click)="reset()" ngbDropdownToggle>{{title}}</a>
    <div [formGroup]="discountForm"  ngbDropdownMenu style="width: 210px;">
        <div class="kt-padding-15">
            <div class="input-group">
                <input
                    [attr.value]="discountData.discount"
                    formControlName="discount"
                    type="number"
                    width="50px"
                    class="form-control discount-value"
                >
                <div class="input-group-prepend">
                    <span
                        (click)="onPercentageDiscountClick(false)"
                        class="input-group-text cursor-pointer"
                        [ngClass]="{'bg-gray': !discountData.isPercentageDiscount, 'bg-white': discountData.isPercentageDiscount}">
                            {{ currency?.symbol }}
                        </span>
                    <span
                        (click)="onPercentageDiscountClick(true)"
                         class="input-group-text cursor-pointer"
                        [ngClass]="{'bg-gray': discountData.isPercentageDiscount, 'bg-white': !discountData.isPercentageDiscount}">%</span>
                </div>
            </div>
            <div class="text-end kt-margin-t-10">
                <button class="btn btn-secondary" ngbDropdownToggle
                    (click)="onCancel()">Cancel</button>
                <button class="btn btn-brand kt-margin-l-10" ngbDropdownToggle
                    (click)="onSubmit()">Done</button>
            </div>
        </div>
    </div>
</div>
